import moment from "moment-jalaali";

export function utcToTime(time, format = "jYYYY/jM/jD HH:mm:ss") {
  if (!time) {
    return null;
  }
  const utc = moment.utc(time);
  return !moment(time).isSame("0001-01-01 00:00:00")
    ? moment(utc).format(format)
    : null;
}
